import {
    Button,
    Img,
    Link,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure
  } from "@chakra-ui/react";
import { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { AppContext } from "../Context/AppContext";

  
  function ManualClose() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {state,handleLogout}=useContext(AppContext)
    const navigate= useNavigate()
    return (
      <>
        <Button onClick={onOpen}>eve.holt@reqres.in</Button>
  
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              <Img src="https://secure.gravatar.com/avatar/d8e75285cfd313f5b55fd96a2d6fd3ad?s=30" />
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <Link>My Profile</Link>
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={handleLogout} >
                LogOut
              </Button>
              <Button >Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }
  export default ManualClose;
  